// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-container {
  font-family: Arial, sans-serif;
  color: #333;

  /* Dark background */
  padding: 20px;
  position: relative;
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;


}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 7px;
  border-radius: 5px;
  background: #ddd;
  /* Light grey background */
  outline: none;
  margin-bottom: 20px;
    opacity: 0.7;
      /* Set transparency (for mouse-over effects on hover) */
      -webkit-transition: .2s;
      /* 0.2 seconds transition on hover */
      transition: opacity .2s;
}


/* Mouse-over effects */
.slider:hover {
  opacity: 1;
  /* Fully shown on mouse-over */
}


.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  background: #c6183d;
  cursor: pointer;
  position: relative;
}



.slider::-moz-range-thumb {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  background: #c6183d;
  cursor: pointer;
}

.slider-marks {
  display: flex;
  justify-content: space-around;
  position: absolute;
  width: 87%;
  margin-top: -12px;

}

.slider-mark {
  position: absolute;
  color: #333;
  font-size: 12px;
}


.simulateurs-wrapper{
margin: 0rem 4rem;
}


.nb{

}

#react-app{
  background-color: #eee;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 0rem;
  display: flex;
  width: 100%;
  /* gap: 4rem; */
}

.value
{
background-color: #eee;
border: none;
width: 120px;
padding: .4rem;
text-align: right;
}


.value:focus {
  outline: none;
  /* Removes the default focus border */
  /* Optional: Add a custom style for focused inputs */
  box-shadow: 0 0 0 2px #ddd;
  /* Example: Adds a blue glow */
}


.simulateur-titre {
  font-size: 2rem;
background-color: #eee;
width: 100%;
color: #000;
text-align: center;
border-radius: 1rem;
padding: 1rem;
}

.btn-full:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}

.btn-full:disabled:hover {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}

.simulator-container
{
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 2rem;
  align-items: center;
  border-radius: 1rem;
  gap: 2rem;
}

.simulator {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 2rem;
  align-items: flex-start;
  justify-content: space-between;
  gap: 2rem;
}



.simulator-right
{
width: 60%;
display: flex;
justify-content: center;
flex-direction: column;
}

.simulator-left{
width: 35%;
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: flex-start;
gap: 1rem;
padding: 2em 2em;
background-color: #eee;
perspective: 1000px;
}


.input-container
{
display: flex;
flex-direction: row;
align-items: flex-start;
justify-content: flex-end;
width: 300px;

}


.btn-full {
  background-color: #c6183d;
  color: white !important;

  text-decoration: none;
  transition: background-color 0.3s ease-in-out;
  padding: 6px 15px;
  border-radius: 15px;
  border: none;
}

.btn-full:hover {
  background-color: #292929 !important;
  color: rgb(255, 255, 255);
  border-color: #292929 !important;
}


.btn-container{
  margin-top: 2rem;
}

.unit{
  padding: .4rem;
  background-color: #c6183d;
  color: white;
  text-align: center;
  width: 50px;
}


.result-row{
  width: 100%;
}
.result-row h3
{
font-size: 1.3em;
}

.result-row .result-row-variable
{
background-color: #fff;
  border: none;
  width: 100%;
  padding: 1.5rem .7rem;
  text-align: left;
  font-size: 1.4rem;
}


.final-result
{
  border-left: 4px solid #c6183d !important;
  font-size: 1.1rem;
font-weight: 700;
  color: #c6183d !important;
}


.slider-thumb {
  transition: left 0.3s ease;
  /* Add transition for smooth movement */
}




.slider-thumb {
  position: absolute;
  bottom: 100%;
  transform: translateX(-50%);
}

.slider-value {
  position: absolute;
  top: 35px;

  /* Adjust the value to properly position the value label */
  /* left: 20%; */
  background-color: rgba(0, 0, 0, 0.7);;
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 4px;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}



.simulateurs-tabs>.nav-link {
  border: none;
  border-left: 4px solid transparent;
  /* Fond gris pour les onglets inactifs */
  color: #000 !important;
  /* Couleur du texte pour les onglets inactifs */
  margin-right: 0 !important;
  padding: 1rem !important;

}



.simulateurs-tabs>.nav-link:hover {
  border-left-color: #c6183d;
  /* Couleur de survol pour les onglets */
}

.simulateurs-tabs>.nav-link.active {
  /* Fond blanc pour l'onglet actif */
  color: #c6183d !important;
  background-color: #e7e7e7 !important;
  /* Couleur du texte pour l'onglet actif */
  border-left: 4px solid #c6183d;
  /* Bordure rouge à gauche pour l'onglet actif */
  border-bottom: none;
  /* width: 100% !important; */
}

.tab-content>.tab-pane {
  /* border: 1px solid #2e2b2b; */
  border-left: none;
  padding: -5rem;
  margin-bottom: 1rem;
  color: #000 !important;
}



.simulateurs-list {
  display: flex;
  flex-direction: column;
}

.simulateurs-list h5 {
  line-height: 1.7rem;
}

.simulateurs-list-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}


@media (max-width: 987px) {
  .simulator {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    padding: 1rem;
  }

  .simulator-right {
    width: 100%;

  }

  .simulator-left {
    width: 100%;
  }

  .simulateur-titre{
    font-size: 1.5rem;
  }

  .simulator-container{
padding: 1rem;
  }

    .slider-container{
padding: .5rem;
    }

        #react-app{
          padding: 1rem;
        }

                .slider-marks{
                  overflow-x: hidden;
                  height: 30px;
                }


                                .simulateurs-wrapper {
                                  margin: 2rem 0rem;
                                }
}
`, "",{"version":3,"sources":["webpack://./js/src/simulateur.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,WAAW;;EAEX,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;;AAGrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;IACjB,YAAY;MACV,uDAAuD;MACvD,uBAAuB;MACvB,oCAAoC;MACpC,uBAAuB;AAC7B;;;AAGA,uBAAuB;AACvB;EACE,UAAU;EACV,8BAA8B;AAChC;;;AAGA;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;;;AAIA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,iBAAiB;;AAEnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;;AAGA;AACA,iBAAiB;AACjB;;;AAGA;;AAEA;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;;AAEA,sBAAsB;AACtB,YAAY;AACZ,YAAY;AACZ,cAAc;AACd,iBAAiB;AACjB;;;AAGA;EACE,aAAa;EACb,qCAAqC;EACrC,oDAAoD;EACpD,0BAA0B;EAC1B,8BAA8B;AAChC;;;AAGA;EACE,eAAe;AACjB,sBAAsB;AACtB,WAAW;AACX,WAAW;AACX,kBAAkB;AAClB,mBAAmB;AACnB,aAAa;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;;;AAIA;;AAEA,UAAU;AACV,aAAa;AACb,uBAAuB;AACvB,sBAAsB;AACtB;;AAEA;AACA,UAAU;AACV,aAAa;AACb,sBAAsB;AACtB,uBAAuB;AACvB,2BAA2B;AAC3B,SAAS;AACT,gBAAgB;AAChB,sBAAsB;AACtB,mBAAmB;AACnB;;;AAGA;;AAEA,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,yBAAyB;AACzB,YAAY;;AAEZ;;;AAGA;EACE,yBAAyB;EACzB,uBAAuB;;EAEvB,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;;AAGA;EACE,WAAW;AACb;AACA;;AAEA,gBAAgB;AAChB;;AAEA;;AAEA,sBAAsB;EACpB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;;EAEE,yCAAyC;EACzC,iBAAiB;AACnB,gBAAgB;EACd,yBAAyB;AAC3B;;;AAGA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;;;;AAKA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;;EAET,0DAA0D;EAC1D,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;;;AAIA;EACE,YAAY;EACZ,kCAAkC;EAClC,wCAAwC;EACxC,sBAAsB;EACtB,+CAA+C;EAC/C,0BAA0B;EAC1B,wBAAwB;;AAE1B;;;;AAIA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,oCAAoC;EACpC,yCAAyC;EACzC,8BAA8B;EAC9B,+CAA+C;EAC/C,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;;AAGA;EACE;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;;EAEb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;AACF,aAAa;EACX;;IAEE;AACJ,cAAc;IACV;;QAEI;UACE,aAAa;QACf;;gBAEQ;kBACE,kBAAkB;kBAClB,YAAY;gBACd;;;gCAGgB;kCACE,iBAAiB;gCACnB;AAChC","sourcesContent":[".slider-container {\n  font-family: Arial, sans-serif;\n  color: #333;\n\n  /* Dark background */\n  padding: 20px;\n  position: relative;\n}\n\n.slider-labels {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n\n\n}\n\n.slider {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 7px;\n  border-radius: 5px;\n  background: #ddd;\n  /* Light grey background */\n  outline: none;\n  margin-bottom: 20px;\n    opacity: 0.7;\n      /* Set transparency (for mouse-over effects on hover) */\n      -webkit-transition: .2s;\n      /* 0.2 seconds transition on hover */\n      transition: opacity .2s;\n}\n\n\n/* Mouse-over effects */\n.slider:hover {\n  opacity: 1;\n  /* Fully shown on mouse-over */\n}\n\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  height: 25px;\n  width: 25px;\n  border-radius: 50%;\n  background: #c6183d;\n  cursor: pointer;\n  position: relative;\n}\n\n\n\n.slider::-moz-range-thumb {\n  height: 25px;\n  width: 25px;\n  border-radius: 50%;\n  background: #c6183d;\n  cursor: pointer;\n}\n\n.slider-marks {\n  display: flex;\n  justify-content: space-around;\n  position: absolute;\n  width: 87%;\n  margin-top: -12px;\n\n}\n\n.slider-mark {\n  position: absolute;\n  color: #333;\n  font-size: 12px;\n}\n\n\n.simulateurs-wrapper{\nmargin: 0rem 4rem;\n}\n\n\n.nb{\n\n}\n\n#react-app{\n  background-color: #eee;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 0rem;\n  display: flex;\n  width: 100%;\n  /* gap: 4rem; */\n}\n\n.value\n{\nbackground-color: #eee;\nborder: none;\nwidth: 120px;\npadding: .4rem;\ntext-align: right;\n}\n\n\n.value:focus {\n  outline: none;\n  /* Removes the default focus border */\n  /* Optional: Add a custom style for focused inputs */\n  box-shadow: 0 0 0 2px #ddd;\n  /* Example: Adds a blue glow */\n}\n\n\n.simulateur-titre {\n  font-size: 2rem;\nbackground-color: #eee;\nwidth: 100%;\ncolor: #000;\ntext-align: center;\nborder-radius: 1rem;\npadding: 1rem;\n}\n\n.btn-full:disabled {\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n}\n\n.btn-full:disabled:hover {\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n}\n\n.simulator-container\n{\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  padding: 2rem;\n  align-items: center;\n  border-radius: 1rem;\n  gap: 2rem;\n}\n\n.simulator {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  padding: 2rem;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 2rem;\n}\n\n\n\n.simulator-right\n{\nwidth: 60%;\ndisplay: flex;\njustify-content: center;\nflex-direction: column;\n}\n\n.simulator-left{\nwidth: 35%;\ndisplay: flex;\nflex-direction: column;\nalign-items: flex-start;\njustify-content: flex-start;\ngap: 1rem;\npadding: 2em 2em;\nbackground-color: #eee;\nperspective: 1000px;\n}\n\n\n.input-container\n{\ndisplay: flex;\nflex-direction: row;\nalign-items: flex-start;\njustify-content: flex-end;\nwidth: 300px;\n\n}\n\n\n.btn-full {\n  background-color: #c6183d;\n  color: white !important;\n\n  text-decoration: none;\n  transition: background-color 0.3s ease-in-out;\n  padding: 6px 15px;\n  border-radius: 15px;\n  border: none;\n}\n\n.btn-full:hover {\n  background-color: #292929 !important;\n  color: rgb(255, 255, 255);\n  border-color: #292929 !important;\n}\n\n\n.btn-container{\n  margin-top: 2rem;\n}\n\n.unit{\n  padding: .4rem;\n  background-color: #c6183d;\n  color: white;\n  text-align: center;\n  width: 50px;\n}\n\n\n.result-row{\n  width: 100%;\n}\n.result-row h3\n{\nfont-size: 1.3em;\n}\n\n.result-row .result-row-variable\n{\nbackground-color: #fff;\n  border: none;\n  width: 100%;\n  padding: 1.5rem .7rem;\n  text-align: left;\n  font-size: 1.4rem;\n}\n\n\n.final-result\n{\n  border-left: 4px solid #c6183d !important;\n  font-size: 1.1rem;\nfont-weight: 700;\n  color: #c6183d !important;\n}\n\n\n.slider-thumb {\n  transition: left 0.3s ease;\n  /* Add transition for smooth movement */\n}\n\n\n\n\n.slider-thumb {\n  position: absolute;\n  bottom: 100%;\n  transform: translateX(-50%);\n}\n\n.slider-value {\n  position: absolute;\n  top: 35px;\n\n  /* Adjust the value to properly position the value label */\n  /* left: 20%; */\n  background-color: rgba(0, 0, 0, 0.7);;\n  font-size: 10px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n\n\n.simulateurs-tabs>.nav-link {\n  border: none;\n  border-left: 4px solid transparent;\n  /* Fond gris pour les onglets inactifs */\n  color: #000 !important;\n  /* Couleur du texte pour les onglets inactifs */\n  margin-right: 0 !important;\n  padding: 1rem !important;\n\n}\n\n\n\n.simulateurs-tabs>.nav-link:hover {\n  border-left-color: #c6183d;\n  /* Couleur de survol pour les onglets */\n}\n\n.simulateurs-tabs>.nav-link.active {\n  /* Fond blanc pour l'onglet actif */\n  color: #c6183d !important;\n  background-color: #e7e7e7 !important;\n  /* Couleur du texte pour l'onglet actif */\n  border-left: 4px solid #c6183d;\n  /* Bordure rouge à gauche pour l'onglet actif */\n  border-bottom: none;\n  /* width: 100% !important; */\n}\n\n.tab-content>.tab-pane {\n  /* border: 1px solid #2e2b2b; */\n  border-left: none;\n  padding: -5rem;\n  margin-bottom: 1rem;\n  color: #000 !important;\n}\n\n\n\n.simulateurs-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.simulateurs-list h5 {\n  line-height: 1.7rem;\n}\n\n.simulateurs-list-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n\n@media (max-width: 987px) {\n  .simulator {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2rem;\n    padding: 1rem;\n  }\n\n  .simulator-right {\n    width: 100%;\n\n  }\n\n  .simulator-left {\n    width: 100%;\n  }\n\n  .simulateur-titre{\n    font-size: 1.5rem;\n  }\n\n  .simulator-container{\npadding: 1rem;\n  }\n\n    .slider-container{\npadding: .5rem;\n    }\n\n        #react-app{\n          padding: 1rem;\n        }\n\n                .slider-marks{\n                  overflow-x: hidden;\n                  height: 30px;\n                }\n\n\n                                .simulateurs-wrapper {\n                                  margin: 2rem 0rem;\n                                }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
